import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import { Checkbox } from "@components/form";
import { useState } from "@helpers/Store";
import * as Type from "@interface/index";
import * as Middleware from "@middlewares/index";

interface IProps {
  currentStep: number;
  maxStep: number;
  setCurrentStep: (value: number) => void;
  companyTypesList: number[];
  networkingProfile: {
    interestCompanyTypes: number[];
    languages: number[];
    directions: number[];
    specializations: number[];
    about: string;
  };
  required?: boolean;
  updateNetworkingProfile: any;
}

const RegStep1 = ({
  currentStep,
  maxStep,
  setCurrentStep,
  companyTypesList,
  networkingProfile,
  required,
  updateNetworkingProfile,
}: IProps): ReactElement => {
  const isContactsValid = useSelector(
    (state: any) => state.Profile.isContactsValid
  );

  const onCheckHandler = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ): void => {
    if (
      networkingProfile?.interestCompanyTypes?.includes(+event.target.value)
    ) {
      networkingProfile?.interestCompanyTypes?.splice(
        networkingProfile?.interestCompanyTypes?.indexOf(+event.target.value),
        1
      );
    } else {
      networkingProfile?.interestCompanyTypes?.push(+event.target.value);
    }
  };

  const onSubmitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!isContactsValid) {
      let ProgressAlert: any;
      await Middleware.Ui.Alert.open("Process", {
        text: "Обновите ваши контактные данные для продолжения регистрации",
        component: (c: any) => {
          ProgressAlert = c;
        },
      });
      ProgressAlert.setStatus("danger");
      ProgressAlert.startTimer();
    } else if (networkingProfile?.interestCompanyTypes?.length > 0) {
      updateNetworkingProfile(networkingProfile);
    } else {
      let ProgressAlert: any;
      await Middleware.Ui.Alert.open("Process", {
        text: "Выберите хотя бы одно значение",
        component: (c: any) => {
          ProgressAlert = c;
        },
      });
      ProgressAlert.setStatus("danger");
      ProgressAlert.startTimer();
    }
  };

  return (
    <>
      <section className="cabinet__block">
        <form onSubmit={onSubmitHandler} className="profile-netw-step">
          <div className="profile-netw-step__header">
            <span> Шаг {currentStep}</span> / {maxStep}
          </div>
          <div className="profile-netw-step__body">
            <div className="profile-netw-step__body-header">
              <p className="profile-netw-step__title">
                {required ? <span>* </span> : <></>}С компаниями какого типа вы
                ищете контакты?
              </p>
              <p className="profile-netw-step__required">
                {required
                  ? "Обязательный пункт"
                  : "Вы можете заполнить этот пункт потом"}
              </p>
            </div>

            <p className="profile-netw-step__desc">
              Выберите хотя бы одно значение
            </p>
            <div className="profile-netw-step__main profile-netw-step__main--checkbox-list">
              {companyTypesList?.map((Item: any, index: number) => {
                return (
                  <Checkbox
                    key={index}
                    name="languages"
                    type="profile"
                    placeholder={Item.name}
                    value={Item.id}
                    hiddenInput
                    checked={networkingProfile?.interestCompanyTypes?.includes(
                      Item.id
                    )}
                    onChange={onCheckHandler}
                  />
                );
              })}
            </div>
          </div>

          <div className="profile-netw-step__footer">
            <button type="submit" className="btn btn--red">
              Дальше
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default RegStep1;
